export enum ROUTING {
  HOME = 'Anasayfa',
  CURRENCY = 'Canli-Piyasa',
  GOLD = 'Bilgi-Toplumu',
  INFORMATION = 'Hakkimizda',
  CONTACT = 'İletisim',
  ERROR = 'Uyum',
  KURUMSAL = 'Kurumsal'
}
